import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import InlineWarning from '../inline-warning';
import translate from '../../_utils/tools/translate';

export default function InvalidPostalCodeWarning({ id, className }) {
  return (
    <InlineWarning
      id={id}
      className={classNames('invalid-postal-code-warning', className)}
      dataTestId="invalid-zip-code-warning">
      Please enter a valid {translate('zip code')}.
    </InlineWarning>
  );
}

InvalidPostalCodeWarning.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

InvalidPostalCodeWarning.defaultProps = {
  id: 'invalid-zip-code-warning',
  className: '',
};
